$(document).ready(function() {
    if ($('.content__description a').length > 0) {
        $('.content__description a').append('<i class="fas fa-arrow-right"></i>');
    }

    //Show more/less option
    $('.content__description').each(function(index) {
        var content = $(this);

        if ( content.length > 0 && content.hasClass('content__fix_height') ) {            

            if ( content.height() > 120 ) {

                content.addClass('content__fix_height_st');

                var show_more_btn = content.next('.content__show_more_opt');
                show_more_btn.show();            
        
                show_more_btn.click(() => {

                    content.toggleClass('content__fix_height_st');
        
                    if(window.location.href.indexOf("/bg/") > -1) {
                        show_more_btn.text(function(i, text){
                            return text === "Покажи още" ? "Виж по-малко" : "Покажи още";
                        });
                    } else {
                        show_more_btn.text(function(i, text){
                            return text === "Show more" ? "See less" : "Show more";
                        });
                    }
                });
            }
        }
    });    
});